import { Long } from "../../helpers";
export const AminoConverter = {
  "/gravity.v1.MsgValsetConfirm": {
    aminoType: "/gravity.v1.MsgValsetConfirm",
    toAmino: ({
      nonce,
      orchestrator,
      ethAddress,
      signature
    }) => {
      return {
        nonce: nonce.toString(),
        orchestrator,
        eth_address: ethAddress,
        signature
      };
    },
    fromAmino: ({
      nonce,
      orchestrator,
      eth_address,
      signature
    }) => {
      return {
        nonce: Long.fromString(nonce),
        orchestrator,
        ethAddress: eth_address,
        signature
      };
    }
  },
  "/gravity.v1.MsgSendToEth": {
    aminoType: "/gravity.v1.MsgSendToEth",
    toAmino: ({
      sender,
      ethDest,
      amount,
      bridgeFee
    }) => {
      return {
        sender,
        eth_dest: ethDest,
        amount: {
          denom: amount.denom,
          amount: amount.amount
        },
        bridge_fee: {
          denom: bridgeFee.denom,
          amount: amount.amount
        }
      };
    },
    fromAmino: ({
      sender,
      eth_dest,
      amount,
      bridge_fee
    }) => {
      return {
        sender,
        ethDest: eth_dest,
        amount: {
          denom: amount.denom,
          amount: amount.amount
        },
        bridgeFee: {
          denom: bridge_fee.denom,
          amount: bridge_fee.amount
        }
      };
    }
  },
  "/gravity.v1.MsgRequestBatch": {
    aminoType: "/gravity.v1.MsgRequestBatch",
    toAmino: ({
      sender,
      denom
    }) => {
      return {
        sender,
        denom
      };
    },
    fromAmino: ({
      sender,
      denom
    }) => {
      return {
        sender,
        denom
      };
    }
  },
  "/gravity.v1.MsgConfirmBatch": {
    aminoType: "/gravity.v1.MsgConfirmBatch",
    toAmino: ({
      nonce,
      tokenContract,
      ethSigner,
      orchestrator,
      signature
    }) => {
      return {
        nonce: nonce.toString(),
        token_contract: tokenContract,
        eth_signer: ethSigner,
        orchestrator,
        signature
      };
    },
    fromAmino: ({
      nonce,
      token_contract,
      eth_signer,
      orchestrator,
      signature
    }) => {
      return {
        nonce: Long.fromString(nonce),
        tokenContract: token_contract,
        ethSigner: eth_signer,
        orchestrator,
        signature
      };
    }
  },
  "/gravity.v1.MsgConfirmLogicCall": {
    aminoType: "/gravity.v1.MsgConfirmLogicCall",
    toAmino: ({
      invalidationId,
      invalidationNonce,
      ethSigner,
      orchestrator,
      signature
    }) => {
      return {
        invalidation_id: invalidationId,
        invalidation_nonce: invalidationNonce.toString(),
        eth_signer: ethSigner,
        orchestrator,
        signature
      };
    },
    fromAmino: ({
      invalidation_id,
      invalidation_nonce,
      eth_signer,
      orchestrator,
      signature
    }) => {
      return {
        invalidationId: invalidation_id,
        invalidationNonce: Long.fromString(invalidation_nonce),
        ethSigner: eth_signer,
        orchestrator,
        signature
      };
    }
  },
  "/gravity.v1.MsgSendToCosmosClaim": {
    aminoType: "/gravity.v1.MsgSendToCosmosClaim",
    toAmino: ({
      eventNonce,
      blockHeight,
      tokenContract,
      amount,
      ethereumSender,
      cosmosReceiver,
      orchestrator
    }) => {
      return {
        event_nonce: eventNonce.toString(),
        block_height: blockHeight.toString(),
        token_contract: tokenContract,
        amount,
        ethereum_sender: ethereumSender,
        cosmos_receiver: cosmosReceiver,
        orchestrator
      };
    },
    fromAmino: ({
      event_nonce,
      block_height,
      token_contract,
      amount,
      ethereum_sender,
      cosmos_receiver,
      orchestrator
    }) => {
      return {
        eventNonce: Long.fromString(event_nonce),
        blockHeight: Long.fromString(block_height),
        tokenContract: token_contract,
        amount,
        ethereumSender: ethereum_sender,
        cosmosReceiver: cosmos_receiver,
        orchestrator
      };
    }
  },
  "/gravity.v1.MsgBatchSendToEthClaim": {
    aminoType: "/gravity.v1.MsgBatchSendToEthClaim",
    toAmino: ({
      eventNonce,
      blockHeight,
      batchNonce,
      tokenContract,
      orchestrator
    }) => {
      return {
        event_nonce: eventNonce.toString(),
        block_height: blockHeight.toString(),
        batch_nonce: batchNonce.toString(),
        token_contract: tokenContract,
        orchestrator
      };
    },
    fromAmino: ({
      event_nonce,
      block_height,
      batch_nonce,
      token_contract,
      orchestrator
    }) => {
      return {
        eventNonce: Long.fromString(event_nonce),
        blockHeight: Long.fromString(block_height),
        batchNonce: Long.fromString(batch_nonce),
        tokenContract: token_contract,
        orchestrator
      };
    }
  },
  "/gravity.v1.MsgValsetUpdatedClaim": {
    aminoType: "/gravity.v1.MsgValsetUpdatedClaim",
    toAmino: ({
      eventNonce,
      valsetNonce,
      blockHeight,
      members,
      rewardAmount,
      rewardToken,
      orchestrator
    }) => {
      return {
        event_nonce: eventNonce.toString(),
        valset_nonce: valsetNonce.toString(),
        block_height: blockHeight.toString(),
        members: members.map(el0 => ({
          power: el0.power.toString(),
          ethereum_address: el0.ethereumAddress
        })),
        reward_amount: rewardAmount,
        reward_token: rewardToken,
        orchestrator
      };
    },
    fromAmino: ({
      event_nonce,
      valset_nonce,
      block_height,
      members,
      reward_amount,
      reward_token,
      orchestrator
    }) => {
      return {
        eventNonce: Long.fromString(event_nonce),
        valsetNonce: Long.fromString(valset_nonce),
        blockHeight: Long.fromString(block_height),
        members: members.map(el0 => ({
          power: Long.fromString(el0.power),
          ethereumAddress: el0.ethereum_address
        })),
        rewardAmount: reward_amount,
        rewardToken: reward_token,
        orchestrator
      };
    }
  },
  "/gravity.v1.MsgERC20DeployedClaim": {
    aminoType: "/gravity.v1.MsgERC20DeployedClaim",
    toAmino: ({
      eventNonce,
      blockHeight,
      cosmosDenom,
      tokenContract,
      name,
      symbol,
      decimals,
      orchestrator
    }) => {
      return {
        event_nonce: eventNonce.toString(),
        block_height: blockHeight.toString(),
        cosmos_denom: cosmosDenom,
        token_contract: tokenContract,
        name,
        symbol,
        decimals: decimals.toString(),
        orchestrator
      };
    },
    fromAmino: ({
      event_nonce,
      block_height,
      cosmos_denom,
      token_contract,
      name,
      symbol,
      decimals,
      orchestrator
    }) => {
      return {
        eventNonce: Long.fromString(event_nonce),
        blockHeight: Long.fromString(block_height),
        cosmosDenom: cosmos_denom,
        tokenContract: token_contract,
        name,
        symbol,
        decimals: Long.fromString(decimals),
        orchestrator
      };
    }
  },
  "/gravity.v1.MsgLogicCallExecutedClaim": {
    aminoType: "/gravity.v1.MsgLogicCallExecutedClaim",
    toAmino: ({
      eventNonce,
      blockHeight,
      invalidationId,
      invalidationNonce,
      orchestrator
    }) => {
      return {
        event_nonce: eventNonce.toString(),
        block_height: blockHeight.toString(),
        invalidation_id: invalidationId,
        invalidation_nonce: invalidationNonce.toString(),
        orchestrator
      };
    },
    fromAmino: ({
      event_nonce,
      block_height,
      invalidation_id,
      invalidation_nonce,
      orchestrator
    }) => {
      return {
        eventNonce: Long.fromString(event_nonce),
        blockHeight: Long.fromString(block_height),
        invalidationId: invalidation_id,
        invalidationNonce: Long.fromString(invalidation_nonce),
        orchestrator
      };
    }
  },
  "/gravity.v1.MsgSetOrchestratorAddress": {
    aminoType: "/gravity.v1.MsgSetOrchestratorAddress",
    toAmino: ({
      validator,
      orchestrator,
      ethAddress
    }) => {
      return {
        validator,
        orchestrator,
        eth_address: ethAddress
      };
    },
    fromAmino: ({
      validator,
      orchestrator,
      eth_address
    }) => {
      return {
        validator,
        orchestrator,
        ethAddress: eth_address
      };
    }
  },
  "/gravity.v1.MsgCancelSendToEth": {
    aminoType: "/gravity.v1.MsgCancelSendToEth",
    toAmino: ({
      transactionId,
      sender
    }) => {
      return {
        transaction_id: transactionId.toString(),
        sender
      };
    },
    fromAmino: ({
      transaction_id,
      sender
    }) => {
      return {
        transactionId: Long.fromString(transaction_id),
        sender
      };
    }
  },
  "/gravity.v1.MsgSubmitBadSignatureEvidence": {
    aminoType: "/gravity.v1.MsgSubmitBadSignatureEvidence",
    toAmino: ({
      subject,
      signature,
      sender
    }) => {
      return {
        subject: {
          type_url: subject.typeUrl,
          value: subject.value
        },
        signature,
        sender
      };
    },
    fromAmino: ({
      subject,
      signature,
      sender
    }) => {
      return {
        subject: {
          typeUrl: subject.type_url,
          value: subject.value
        },
        signature,
        sender
      };
    }
  }
};